import { render, staticRenderFns } from "./days-supply-dialog.vue?vue&type=template&id=2e780ee3&scoped=true"
import script from "./days-supply-dialog.vue?vue&type=script&lang=js"
export * from "./days-supply-dialog.vue?vue&type=script&lang=js"
import style0 from "./days-supply-dialog.vue?vue&type=style&index=0&id=2e780ee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e780ee3",
  null
  
)

export default component.exports